"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReactOneDriveFilePickerType = exports.ReactOneDriveFilePicker = void 0;
var onedrive_picker_1 = require("./onedrive-picker");
Object.defineProperty(exports, "ReactOneDriveFilePicker", { enumerable: true, get: function () { return onedrive_picker_1.default; } });
exports.ReactOneDriveFilePickerType = require("./onedrive-picker");
//# sourceMappingURL=index.js.map